import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  jobTitleList,
  jobTitleDetails,
  jobTitleAssignedUsers,
  VariableOptionItem,
} from './job-title-model';
import { Meta } from '../../../../common/models/api-response.model';
import { ENDPOINTS } from '../../../../common/constants/endpoints.constants';
import { SearchEnum } from '../../../../common/enums/search.enum';

@Injectable({
  providedIn: 'root',
})
export class JobTitleService {
  http = inject(HttpClient);
  readonly JOB_TITLE_ID = '{jobTitleId}';

  getJobTitleList(
    page: number,
    per_page: number,
    sort?: { key: string; value: 'asc' | 'desc' },
    filter?: string,
    search?: string
  ) {
    let params = new HttpParams()
      .append('page', page)
      .append('per_page', per_page);
    if (sort?.key) {
      params = params.append(`sort[${sort.key}]`, sort.value);
    }
    if (filter && filter !== 'all') {
      params = params.append('filters[state]', filter);
    }
    if (search) {
      params = params.append(SearchEnum.keyword, search);
    }
    return this.http.get<{ data: jobTitleList[]; meta: Meta }>(
      ENDPOINTS.Dashboard.JobTitles.List,
      { params }
    );
  }

  getJobTitleDetails(jobTitleId: string) {
    return this.http.get<{ data: jobTitleDetails }>(
      ENDPOINTS.Dashboard.JobTitles.Details.replace(
        this.JOB_TITLE_ID,
        jobTitleId
      )
    );
  }

  getJobTitleUsers(
    jobTitleId: string,
    page: number,
    per_page: number,
    searchTerm: string
  ) {
    return this.http.get<{
      data: jobTitleAssignedUsers[];
      meta: { total: string; last_page: number };
    }>(
      `${ENDPOINTS.Dashboard.JobTitles.Users.replace(this.JOB_TITLE_ID, jobTitleId)}?page=${page}&per_page=${per_page}&filters[search]=${searchTerm}`
    );
  }

  addJobTitle(jobTitleDetails: any) {
    return this.http.post(
      ENDPOINTS.Dashboard.JobTitles.Create,
      jobTitleDetails
    );
  }

  editJobTitle(jobTitleDetails: any, jobTitleId: string) {
    return this.http.post(
      ENDPOINTS.Dashboard.JobTitles.Update.replace(
        this.JOB_TITLE_ID,
        jobTitleId
      ),
      jobTitleDetails
    );
  }

  activateJobTitle(jobTitleId: string) {
    return this.http.put(
      ENDPOINTS.Dashboard.JobTitles.Activate.replace(
        this.JOB_TITLE_ID,
        jobTitleId
      ),
      {}
    );
  }

  deactivateJobTitle(jobTitleId: string) {
    return this.http.put(
      ENDPOINTS.Dashboard.JobTitles.Deactivate.replace(
        this.JOB_TITLE_ID,
        jobTitleId
      ),
      {}
    );
  }

  deleteJobTitle(jobTitleId: string) {
    return this.http.delete(
      ENDPOINTS.Dashboard.JobTitles.Delete.replace(
        this.JOB_TITLE_ID,
        jobTitleId
      )
    );
  }

  getVariableOptions(variableKey: string) {
    const params = new HttpParams()
      .append('filters[variable][module]', 'user_management')
      .append('filters[variable][key]', variableKey)
      .append('sort[label][type]', 'ASC');
    return this.http.get<{ data: VariableOptionItem[] }>(
      ENDPOINTS.Lookup.variableOptions,
      { params }
    );
  }
}
